var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopbaruser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDD87E",
    d: "M21.002,21.011v-5h-10v5c-4.971,0-11,3.029-11,8c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3 C32.002,24.04,25.973,21.011,21.002,21.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDD87E",
    d: "M20.002,1.011h-8c-2.209,0-4,1.791-4,4v5c0,5.522,3.582,10,8,10s8-4.478,8-10v-5 C24.002,2.802,22.211,1.011,20.002,1.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434854",
    d: "M18.002,0.011h-4c-4,0-7,3-7,7c0,2.61,0.673,3.819,3,4.645V8.011c3.795,0,7.263-1.342,10.005-3.551 c0.745,1.223,1.995,1.551,1.995,1.551v5.645c2.327-0.825,3-2.034,3-4.645C25.002,3.011,22.002,0.011,18.002,0.011z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EDD87E",
    cx: 24.002,
    cy: 11.511,
    rx: 1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EDD87E",
    cx: 8.002,
    cy: 11.511,
    rx: 1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.002,19.151V17.81c-1.37,1.375-3.106,2.201-5,2.201s-3.63-0.826-5-2.201v1.342 c1.432,1.173,3.15,1.859,5,1.859S19.57,20.324,21.002,19.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#469FCC",
    d: "M21.002,21.011c0,2.209-2.238,4-5,4s-5-1.791-5-4c-4.971,0-11,3.029-11,8c0,1.657,1.343,3,3,3h26 c1.657,0,3-1.343,3-3C32.002,24.04,25.973,21.011,21.002,21.011z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbaruser);
export default __webpack_public_path__ + "static/media/topbaruser.7b45acdbd8cfeaa0a06d865cea8df95e.svg";
export { ForwardRef as ReactComponent };